import { DatePipe, Location } from '@angular/common';
import { ChangeDetectorRef, Component, DoCheck, OnDestroy, OnInit, Renderer2, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { ISOCountryCode } from '@core/enums/ISO-country-code.enum';
import { Announcement } from '@core/models/announcement.model';
import { EwalletVerification } from '@core/models/ewallet-verification.model';
import { AnnouncementHttpService } from '@core/services/announcement-http.service';
import { AuthHttpService } from '@core/services/auth-http.service';
import { ContactListHttpService } from '@core/services/contact-list-http.service';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { EwalletVerificationHttpService } from '@core/services/ewallet-verification-http.service';
import { LocationHttpService } from '@core/services/location-http.service';
import { PortalMemberProfileHttpService } from '@core/services/portal-member-profile-http.service';
import { changeProfile, login } from '@core/store/auth/auth.actions';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateService } from '@ngx-translate/core';
import { EwalletVerificationApprovalComponent } from '@shared/ewallet-verification-approval/ewallet-verification-approval.component';
import { EwalletVerificationRejectionComponent } from '@shared/ewallet-verification-rejection/ewallet-verification-rejection.component';
import { PopupConnectionErrorComponent } from '@shared/popup-connection-error/popup-connection-error.component';
import { BankAccountDataService } from '@views/modules/member/services/bank-account-data.service';
import countryISOMapping from 'country-iso-3-to-2';
import * as moment from 'moment';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { SweetAlertCustomClass } from 'sweetalert2';
import { version } from '../../package.json';
import { EmailVerificationHttpService } from './core/services/email-verification-http.service';
import { OneSignalHttpService } from './core/services/one-signal-http.service';
import { SeoService } from './core/services/seo.service';
import { SessionService } from './core/services/session.service';
import { isLoggedIn } from './core/store/auth/auth.selectors';
import { ForgotPasswordModalComponent } from './shared/forgot-password-modal/forgot-password-modal.component';
import { AppState } from './store/reducers';
import { RewardSwalComponent } from './views/modules/member/dialogs/reward-modal/reward-swal/reward-swal.component';
import { FirebaseMessagingService } from '@core/services/firebase-messaging-service';
import { LivechatHttpService } from '@core/services/livechat-http.service';
import { Crisp } from "crisp-sdk-web";
import { Livechat } from '@core/models/livechat.model';
import { LiveChatHttpService } from '@core/services/livechat-http-service';
import { OrientationService } from '@core/services/orientation.service';
import { PPChallengePromotionHttpService } from '@core/services/pp-challenge-promotion-http.service';
import { BTGChallengePromotionHttpService } from '@core/services/btg-challenge-promotion-http.service';
import { PromotionDialogComponent } from '@shared/promotion-dialog/promotion-dialog.component';
import { PortalDepositHttpService } from './core/services/portal-deposit-http.service';
import { AudBankTransferDepositService } from '@views/modules/member/services/aud-banktrasfer-deposit.service';
import { AudBankTransferDepositDataService } from '@views/modules/member/services/aud-banktrasfer-deposit-data.service';

declare var $: any;
declare const window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, DoCheck {

  mode: string = window.mode;
  siteName = (environment.sitePrefix as string).toUpperCase();
  shutdownflag = environment.shutdown;
  pageTitle = '';
  isDesktopDetected = false;
  todayDate = new Date();
  rewardNotice = Number(localStorage.getItem('reward_notice'));
  currentURL = this.router.url.split('/');
  page = this.currentURL[this.currentURL.length - 1] === '' || window.location.pathname == '/' ? 'home' : this.currentURL[this.currentURL.length - 1];
  announcements$ = [];
  announcementIds = [];
  campaignCode: string;
  affiliateCode: string;

  showBackButton = false;
  backButtonList = [
    '/signup'
  ];

  ISOCountryCode = ISOCountryCode;

  showChangeCountryNotice = false;
  luckySpinDomain = environment.luckySpinDomain;

  supportedCountry = this.dropdownService.availableCountryAndLanguages;
  supportedLanguage = this.dropdownHttpService.languages;

  customClass: SweetAlertCustomClass = {
    content: 'country-not-available-content'
  };

  // TEMPORARILY
  s3RedirectURL = {
    '/EN50FSD': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+Deposit.png',
    '/EN50FSND': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+No+Deposit.png',
    '/ZH50FSD': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+Deposit.png',
    '/ZH50FSND': 'https://aiodin-pro1.s3.ap-southeast-1.amazonaws.com/promotion/#COUNTRY_LANGUAGE+-+50+Free+Spins+-+No+Deposit.png'
  }
  pathName = '';
  hostname = (window.location.hostname).replace(/^([w]{3}.)(?=[a-z0-9]+)/, '');
  countryCodeToChange: string;
  countryCode: string;
  hideAppBase = window.location.pathname === '/unsupported-country' ? true : false;
  isLoggedIn$: Observable<boolean>;
  mainDomainBlocked: boolean;
  isMember: boolean;
  // This currentDomain mean the most top / parent domain, not the sub domain
  currentDomain: string;

  // TEMPORARY USE TO HIDE LUCKY SPIN WHEEL IN PRODUCTION
  currentEnv = environment.domainEnv;

  // This dialog location is same as in BO
  // The data is hardcoded from BO and not from API
  dialogLocation = [
    { id: 1, name: 'All' },
    { id: 2, name: 'Home' },
    { id: 3, name: 'Deposit' },
    { id: 4, name: 'Withdraw' },
    { id: 5, name: 'Transfer' },
    { id: 6, name: 'Slots-Game' },
    { id: 7, name: 'Casino-Game' },
    { id: 8, name: 'Sports' },
    { id: 9, name: 'Fishing' },
    { id: 10, name: 'Promotion' },
    { id: 11, name: 'Vip' },
    { id: 12, name: 'Contact' }
  ];

  showReminder: boolean = false;
  newLink: string = null;
  currentPage: string;

  onMaintenancePage = false;
  seoSetting: any;
  verificationData: EwalletVerification = null;
  newRequestIncoming = this.ewalletVerificationHttpService.newRequestIncoming;
  hiddenDomains = this.dropdownService.vipHiddenDomains;
  connectionState!: ConnectionState;
  connectionSubscription = new Subscription();
  announcementSubscription = new Subscription();
  liveChatSubscription = new Subscription();

  newPromptIncoming = this.announcementHttpService.newPromptIncoming;
  newVipPromptIncoming = this.announcementHttpService.newVipPromptIncoming;
  rewardPrompt: Announcement = null;
  dialogPrompt: Announcement = null;
  whiteListGameLaunch = ['venomx', 'hasbullatest', 'jianhao', 'jianhao2', 'game01', 'testphase04', 'qprotest'];
  whiteListGameProviderLaunch = ['CQ9', 'FC', 'HABA', 'JDB', 'JILI', 'JK', 'KA', 'MGP', 'LIVE', 
                                'PTI', 'VRNL', 'MAX', 'SBO', '2BC', 'IM', 'IM2', 'TF', 'EVOK', 'SEXY',
                                'GXW', 'WBET', 'EZ', 'DG', 'BG', 'AB', 'SA', 'SSG', 'WE', 'PGS', 'PGS2',
                                'YB', 'XE', 'TTG', 'SIMPLE', 'SG', 'RT2', 'PNG', 'NLC', 'NET2', 'MONKEY',
                                'YL', 'SV388', 'SPRIBE', 'NEX4D', 'MC', 'MAHA', 'LUDO', 'FP', 'EKOR', 'BTG',
                                '365G', 'AVI', 'BOOM', 'HSG', 'WM', 'KM', 'AMBPOKER', 'AMBSLOT'];
  onFullscreenGameLaunch = false;
  isLaunchGameLandscape = 0;
  phase1ResData = null;
  ppPhase1ResultIncoming = this.ppChallengePromotionHttpService.ppPhase1ResultIncoming;
  activePPChallengePromo = localStorage.getItem('activePPChallengePromo') === null ? {} : JSON.parse(localStorage.getItem('activePPChallengePromo'));
  btgPhase1ResultIncoming = this.btgChallengePromotionHttpService.btgPhase1ResultIncoming;
  activeBTGChallengePromo = localStorage.getItem('activeBTGChallengePromo') === null ? {} : JSON.parse(localStorage.getItem('activeBTGChallengePromo'));

  showImage: boolean = false;
  bgImagePath: string = 'assets/images/dpc/main-bg.jpg';

  windowInnerHeight: number;
  private sessionUserChecker = 'session_user_checker';
  private unsubscribe: Subscription[] = [];
  subscription: Subscription;

  audSite = ['QPRO18', 'QPRO19'];
  audTitle = [
    { site:'PPAQ', name: 'PokiesPalace' },
    { site:'OZPK', name: 'OzPokies77' }
  ];
  currentProjectCode = environment.projectCode;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private deviceDetectorService: DeviceDetectorService,
    private authService: AuthHttpService,
    public loadingBar: LoadingBarService,
    private eventEmitterService: EventEmitterService,
    private announcementHttpService: AnnouncementHttpService,
    private datePipe: DatePipe,
    private location: Location,
    public dialog: MatDialog,
    private locationHttpService: LocationHttpService,
    private dropdownService: DropdownHttpService,
    private emailVerificationHttpService: EmailVerificationHttpService,
    private os: OneSignalHttpService,
    private seoService: SeoService,
    private renderer: Renderer2,
    private dropdownHttpService: DropdownHttpService,
    private contactListHttpService: ContactListHttpService,
    private connectionService: ConnectionService,
    private ewalletVerificationHttpService: EwalletVerificationHttpService,
    private bankAccountDataService: BankAccountDataService,
    private cdr: ChangeDetectorRef,
    private portalMemberProfileHttpService: PortalMemberProfileHttpService,
    private sessionService: SessionService,
    private firebaseMessagingService: FirebaseMessagingService,
    private livechatHttpService: LivechatHttpService,
    private liveChatHttpService: LiveChatHttpService,
    private orientationService: OrientationService,
    private ppChallengePromotionHttpService: PPChallengePromotionHttpService,
    private btgChallengePromotionHttpService: BTGChallengePromotionHttpService,
    private portalDepositHttpService: PortalDepositHttpService,
    private audBankTransferDepositService: AudBankTransferDepositService,
    private audBankTransferDepositDataService: AudBankTransferDepositDataService,
  ) {

    //here to decrypt and set items to localstorage if launch page and got param redirectDomain  
    if (window.location.pathname == '/gamelaunch' || window.location.pathname == '/launch-game') {
      let params = this.authService.getUrlParams(window.location.search);
      let redirectDomain = params['redirectDomain'];
      if (redirectDomain && redirectDomain == '1') {
        localStorage.removeItem('gameCategory');
        localStorage.removeItem('gameCode');
        localStorage.removeItem('gameProviderId');
        localStorage.removeItem('gameProviderCode');
        localStorage.removeItem('isPlayTechClicked');
        localStorage.removeItem('gameType');
        localStorage.removeItem('gameMode');
        localStorage.removeItem('gameProviderDemoMode');

        const decrypted_userData = params['userData'];
        const decrypted_userToken = params['accessToken'];
        if (decrypted_userData && decrypted_userToken) {
          let user = JSON.parse(decrypted_userData);
          localStorage.setItem('country_code', user['country_code']);
          localStorage.setItem('user_data', decrypted_userData);
          localStorage.setItem('user_token', decrypted_userToken);
          if (params['gameCode']) localStorage.setItem('gameCode', params['gameCode']);
          if (params['gameProviderId']) localStorage.setItem('gameProviderId', params['gameProviderId']);
          if (params['gameProviderCode']) localStorage.setItem('gameProviderCode', params['gameProviderCode']);
          if (params['gameCategory']) localStorage.setItem('gameCategory', params['gameCategory']);
          if (params['gameType']) localStorage.setItem('gameType', params['gameType']);
          if (params['gameMode']) localStorage.setItem('gameMode', params['gameMode']);
          if (params['isPlayTechClicked']) localStorage.setItem('isPlayTechClicked', params['isPlayTechClicked']);
          if (params['gameProviderDemoMode']) localStorage.setItem('gameProviderDemoMode', params['gameProviderDemoMode']);
          if (params['subCategoryCode']) localStorage.setItem('subCategoryCode', params['subCategoryCode']);
          if (params['lobbyUrl']) localStorage.setItem('lobbyUrl', params['lobbyUrl']);
          if (params['countryCode']) localStorage.setItem('country_code', params['countryCode']);
          if (params['mainDomainUrl']) localStorage.setItem('main_domain_url', params['mainDomainUrl']);
          const userData = localStorage.getItem('user_data');
          const userToken = localStorage.getItem('user_token');
          this.store.dispatch(login({ user: JSON.parse(userData), token: JSON.parse(userToken) }));
        }
      }
    }

    if (environment.production && localStorage.getItem('country_code') === 'SG') {
      document.addEventListener("DOMContentLoaded", () => {
        seoService.setJsonLd();
        seoService.renderer = this.renderer;
      });
    }
    router.events.pipe(
      tap(() => this.authService.getAffiliateAndMarketingParams()),
      filter(event => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      this.checkVersionNew();
      this.getRouteTitle(this.activatedRoute).data
        .pipe(tap(data => {
          if (window.location.pathname === '/forgot-password') {
            this.router.navigate(['/']);
            this.dialog.open(ForgotPasswordModalComponent);
          }
          this.pageTitle = data.title == 'Slots' && this.audSite.includes(environment.projectCode) ? 'Pokies' : data.title;
          // if (this.rewardNotice > 0 && data.title !== 'Reward History' && data.title !== 'Live Chat') {
          //   this.onRewardNotice();
          // }
        }))
        .subscribe((event: NavigationEnd) => {
          this.show();
          if (window.location.pathname == '/gamelaunch' || window.location.pathname == '/launch-game') {
            this.titleService.setTitle(this.pageTitle ? this.pageTitle : '');
          }
          else {
            const match = this.audTitle.find(item => item.site === this.siteName);
            const displayName = match ? match.name : this.siteName;

            this.titleService.setTitle((this.pageTitle ? this.pageTitle + ' | ' : '') + displayName);
          }

          if (!['/casino', '/slots', '/lottery', '/sports', '/fishing', '/esports', '/crash-game', '/table'].includes(event.url)) {
            this.seoService.execute();
          }
        });
    });
    window.onbeforeunload = () => {
      sessionStorage.removeItem('game_providers_balance');
      this.sessionService.decreaseTabCount(this.sessionUserChecker);
    };
  }

  async ngOnInit() {
    this.currentPage = window.location.pathname;
    this.showImage = await this.isValidImage(this.bgImagePath);

    this.windowInnerHeight = window.innerHeight;

    localStorage.setItem('whitelist_game_launch', JSON.stringify(this.whiteListGameLaunch));
    localStorage.setItem('whitelist_game_provider', JSON.stringify(this.whiteListGameProviderLaunch));
    this.orientationService.isLandscape$.subscribe(value => {
      this.isLaunchGameLandscape = value;
    });

    this.subscription = this.store.pipe(select(isLoggedIn)).subscribe(res => {
      if (res) {
        document.body.classList.add('logged-in');
      }
    });
    // Set Smartico integration data
    this.eventEmitterService.smarticoDataEventEmitter.subscribe(data => {

      let smarticoData = `
        window._smartico_user_id = null;
        window._smartico_language = null;
      `;
      if (data.user_id != null && data.user_lang != null) {
        smarticoData = `
          window._smartico_user_id = '${data.user_id}';
          window._smartico_language = '${data.user_lang}';
        `;
      }

      const script = this.renderer.createElement('script');
      script.text = smarticoData;
      this.renderer.appendChild(document.body, script);
    });

    this.newPromptIncoming.subscribe(() => {
      const userData = localStorage.getItem('user_data');
      this.rewardPrompt = AnnouncementHttpService.rewardPrompt;
      if (this.rewardPrompt.updateRewardPrompt == true && JSON.parse(userData).id === this.rewardPrompt.member_account_id) {
        this.eventEmitterService.onUpdateRewardBubble();
        this.onGetAnnouncements(true);
      }
    })

    this.newVipPromptIncoming.subscribe(() => {
      this.dialogPrompt = AnnouncementHttpService.vipDialog;
      if (this.dialogPrompt.updateVipPopup == true) {
        this.onGetAnnouncements()
      }
    })

    if (window.location.href.includes('casino')) {
      localStorage.setItem('gameCategoryCode', 'LC');
      localStorage.setItem('gameCategoryName', 'casino');
    } else if (window.location.href.includes('slots')) {
      localStorage.setItem('gameCategoryCode', 'SL');
      localStorage.setItem('gameCategoryName', 'slots');
    }
    setTimeout(() => {
      this.onMaintenancePage = (window.location.pathname) == '/maintenance' ? true : false;
    }, 500)
    this.onCheckConnection();

    if (window.location.pathname !== '/unsupported-country') {

      // dynamic url for landing page
      const redirect_site_domain = JSON.parse(localStorage.getItem('redirect_site_domain')),
        landing_page_domain = redirect_site_domain.find(x => x.type == 2),
        game_launch_domain = redirect_site_domain.find(x => x.type == 3);
      if (game_launch_domain && window.location.href.includes(game_launch_domain['domain'])) {
        if (landing_page_domain && !(window.location.href.includes('/gamelaunch?redirectDomain'))) {
          let url = ((environment.https ? 'https://' : 'http://') + landing_page_domain['domain']);
          window.location.replace(url);
        }
      }

      localStorage.setItem('countryNotice', (this.showChangeCountryNotice) ? '1' : '0');
      this.isLoggedIn$ = this.store.pipe(select(isLoggedIn));
      this.pathName = window.location.pathname;
      document.body.classList.remove('livechat');
      this.getHostname();

      // Grab and update click count whenever affiliate
      // or marketing campaign param is present from URL
      this.route.queryParams.subscribe((params: Params) => {
        this.campaignCode = params[`campaign`];
        this.affiliateCode = params[`aff`];
        if (this.campaignCode) {
          this.authService.updateCampaignClickCount(this.campaignCode).subscribe();
        }
        if (this.affiliateCode) {
          this.authService.updateAffiliateClickCount(this.affiliateCode).subscribe();
        }
        if (Object.keys(params).length > 0) {
          localStorage.setItem('signupRoute', window.location.href);
          if (!location.href.includes('promotion') && !location.href.includes('login') && !location.href.includes('signup')) {
            const newURL = location.href.split('?')[0];
            window.history.pushState('object', document.title, newURL);
          }
        }
      });

      this.isLoggedIn$.subscribe(async res => {
        this.isMember = res;
        if (res) {
          setTimeout(async () => {
            this.checkReminder();
            this.onLoginVerificationPop();
            this.onLoginPPChallengePop();
            this.onLoginBTGChallengePop();
            var country_code = localStorage.getItem('country_code');
            this.countryCode = localStorage.getItem('country_code');
            if (country_code == 'ID') {
              this.onLoginVerificationPop();
            }

            let user_data = JSON.parse(localStorage.getItem('user_data'));
            let push_noti = user_data?.settings?.push_noti ?? true;

            if (push_noti) {
              if (environment.sitePrefix.toLowerCase() == 'bp77' || environment.sitePrefix.toLowerCase() == 'bp9') {
                this.os.onInit().subscribe();
              }

              // await this.firebaseMessagingService.requestPermission();
              // this.firebaseMessagingService.listenToMessages().subscribe((payload) => {
              //   // TODO: handle foreground message here
              //   console.log('Message received', payload);
              // });
            }

              // check aud user and have pending payment deposit
            if(user_data.currency.code === "AUD") {
              this.portalDepositHttpService.getPendingPaymentAudBankTransferDeposit().subscribe((res) => {
                  if (res.success) {
                    this.audBankTransferDepositDataService.storeLocalStorageForAudTransfer({
                        ...res.data.rows
                    });
                    const lsAudStepTwoDeposit = this.audBankTransferDepositDataService.getAudTransferDeposit();
                    this.audBankTransferDepositService.handleRedirectAudTransferPage(lsAudStepTwoDeposit);
                  }
              });
            }
          }, 200);
        }
      });

      this.onVerifyEmail();
      this.ewalletVerificationPop();
      this.ppChallengePhase1ResultPop();
      this.btgChallengePhase1ResultPop();

      // this.browserInit();

      // Should be after browserInit!
      this.landingPage();

      // Set timeout to prevent get null value for localStorage variable
      setTimeout(() => {
        if (!this.hiddenDomains.includes(window.location.hostname)) {
          this.checkLocation();
        }
      }, 1000)

      const languageCode = localStorage.getItem('language_code');
      const userLocale = localStorage.getItem('user_locale');
      if (languageCode !== null) {
        this.translateService.use((languageCode).toLocaleLowerCase());
      } else {
        if (this.supportedLanguage[userLocale.toUpperCase()] !== undefined) {
          this.translateService.use((userLocale).toLocaleLowerCase());
        };
      }

      const userData = localStorage.getItem('user_data');
      const userToken = localStorage.getItem('user_token');
      if ((userData !== null && userToken !== null) && (userData && userToken)) {
        this.store.dispatch(login({ user: JSON.parse(userData), token: JSON.parse(userToken) }));
      } else {
        // No need call this function as updateCountryAndLanguageEmitter will get trigger when user is loggined
        this.getLiveChatScript();
      }

      this.eventEmitterService.updateCountryAndLanguageEmitter.subscribe(() => {
        localStorage.removeItem('announcements_pop');
        this.getContactUs();
        this.onGetAnnouncements();
        this.getLiveChatScript();
      });

      this.eventEmitterService.fullScreenGameLaunchEventEmitter.subscribe(res => {
        this.onFullscreenGameLaunch = res;
      });

      if (window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') {
        var checkCountryInterval = setInterval(() => {
          if (localStorage.getItem('country_code') !== null) {
            this.countryCode = localStorage.getItem('country_code');
            setTimeout(() => {
              this.getContactUs();
              this.onGetAnnouncements();
              clearInterval(checkCountryInterval);
            }, 1000)
          }
        }, 2000);
      }

      this.redirectToS3Link();
      if (languageCode !== null) {
        languageCode.toLowerCase() === 'zh'
          ? moment.locale('zh-cn')
          : moment.locale(languageCode.toLowerCase());
      }

      if (userData) {
        // TO FORCE UPDATE THE user_data, if all tab is closed and in BO update broadcast will not work so the user_data will outdate.
        var session_user_data = sessionStorage.getItem(this.sessionUserChecker);
        var tabsOpenCount = localStorage.getItem('tabsOpenCount'); // USE TO CHECK IF ONLY 1 TAB IS ACTIVE, IF MORE MEANS user_data is updated
        if (!session_user_data && tabsOpenCount == '1') {
          this.portalMemberProfileHttpService.getProfile()
            .subscribe(data => {
              sessionStorage.setItem(this.sessionUserChecker, 'logged in');
              this.portalMemberProfileHttpService.updateLocalUserData(data);
            });
        }
        // TO FORCE UPDATE THE user_data END
      }

      // Set Smartico user data to null for guest
      if (!this.isUserLoggedIn()) {
        const smarticoData = {
          'user_id': null,
          'user_lang': null
        };
        this.eventEmitterService.onInitSmarticoEventEmitter(smarticoData);
      }
    }

    // Subscribe to live chat script updates
    this.liveChatSubscription = this.livechatHttpService.getScriptUpdates().subscribe(liveChat => {
      this.loadChatScript(liveChat);
    });
  }

  ngDoCheck() {
    this.rewardNotice = Number(localStorage.getItem('reward_notice'));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (screenWidth < 300) { // cater for small screen size
        let viewportMetaTag = document.querySelector('meta[name="viewport"]');
        if (viewportMetaTag) {
          const content = `width=device-width, initial-scale=0.7`;
          this.renderer.setAttribute(viewportMetaTag, 'content', content);
        }
      }
    }, 500);

    if (window.location.pathname !== '/gamelaunch' && window.location.pathname !== '/launch-game') {
      setTimeout(() => {
        const userData = JSON.parse(localStorage.getItem('user_data'));
        if (userData && userData.id) {
          if (!this.authService.isTokenExpired()) {
            if (userData.name !== null || userData.name.length > 0) {
              this.store.dispatch(changeProfile({
                profile: {
                  ...userData,
                  id: userData.id,
                  name: userData.name,
                  member_group: {
                    name: userData.member_group.name,
                    image: userData.member_group.image,
                    trial: userData.member_group.trial
                  }
                }
              }));
            }
          }
        }
      }, 1000);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.map(sb => sb.unsubscribe);
    this.connectionSubscription.unsubscribe();
    this.liveChatSubscription.unsubscribe();
    this.subscription.unsubscribe();
    this.sessionService.decreaseTabCount(this.sessionUserChecker);
  }

  onLuckySpin() {
    this.router.navigate(['/luckyspin']);
  }

  onPreviousPage() {
    this.location.back();
  }

  private getContactUs() {
    this.contactListHttpService.getContactList().subscribe(res => {
      sessionStorage.setItem('contact_us', JSON.stringify(res))
      this.eventEmitterService.onUpdateContactUs();
    });
  }

  onCheckConnection() {
    this.connectionSubscription.add(
      this.connectionService.monitor().pipe(
        tap((newState: ConnectionState) => {
          this.connectionState = newState;
          if (!this.connectionState.hasNetworkConnection) {
            this.dialog.open(PopupConnectionErrorComponent, { width: 'auto' });
          } else {
            this.dialog.closeAll();
          }
        })
      ).subscribe()
    );
  }

  onGetAnnouncements(websocketPop = false) {
    const dateToday = this.datePipe.transform(this.todayDate, 'yyyy-MM-dd');
    if (localStorage.getItem('date_today') !== dateToday) {
      localStorage.setItem('date_today', dateToday);
      localStorage.removeItem('announcements_pop');
      localStorage.removeItem('marquees');
      localStorage.removeItem('maintenances');
    }

    const currentURL = this.router.url.split('/');
    const currentURLRemoveLang = currentURL[currentURL.length - 1].split('?');

    let page = currentURL[currentURL.length - 1] === '' || window.location.pathname == '/' ? 'home' : currentURLRemoveLang[currentURLRemoveLang.length - 1] === '' ? 'home' : currentURLRemoveLang[currentURLRemoveLang.length - 1];
    if (currentURLRemoveLang.length > 1) page = currentURLRemoveLang[0] === '' ? 'home' : currentURLRemoveLang[0];

    this.route.queryParams.subscribe(async (params: Params) => {
      let dialogCode = null;
      if ((params['campaign'] != undefined || params['aff'] != undefined) && params['dialog']) {
        localStorage.setItem('dialog', params['dialog']);
        window.history.replaceState({}, '', `${this.router.url.replace('?dialog=' + params['dialog'], '').replace('&dialog=' + params['dialog'], '')}`);
      }
      else if (params['campaign'] == undefined && params['aff'] == undefined) {
        if (params['dialog']) {
          dialogCode = params['dialog']
          localStorage.setItem('dialog', params['dialog']);
          window.history.replaceState({}, '', `${this.router.url.replace('?dialog=' + dialogCode, '').replace('&dialog=' + dialogCode, '')}`);
        }
        else {
          dialogCode = localStorage.getItem('dialog');
        }
      }

      this.announcementSubscription.unsubscribe();
      this.announcementSubscription = this.announcementHttpService.getPopUp(dialogCode).subscribe(res => {
        if (dialogCode == null) {
          let announcementPopList = JSON.parse(localStorage.getItem('announcements_pop'));
          let announcementPopCodes = res.map(function (i) {
            return i['code'];
          });
          if (announcementPopCodes.length > 0 && announcementPopList != null) {
            announcementPopList = announcementPopList.filter(x => announcementPopCodes.includes(x.code));
            localStorage.setItem('announcements_pop', JSON.stringify(announcementPopList));
          }
        }

        const announcementPop = [];
        res.map((announcement: any) => {
          if (res.length > 0) announcement.content[0].session = announcement.session;
          // announcement.platform : 1 = All , 2 == Mobile , 3 == Desktop
          if (announcement.platform == 1 || announcement.platform == 2) {
            // announcement.session :  1 = All , 2 == Before login , 3 == after login
            if (localStorage.getItem('user_data') != null) {
              if (announcement.session == 1 || announcement.session == 3) {
                let seenStatus = 0;
                if (localStorage.getItem('announcements_pop') !== undefined && localStorage.getItem('announcements_pop') !== null) {
                  let announcementList = JSON.parse(localStorage.getItem('announcements_pop'))
                  let announcementListFilter = announcementList.filter(x => x.id == announcement.id)
                  if (announcementListFilter.length > 0) {
                    if (announcementListFilter[0].always_pop == 0) {
                      announcementList = announcementList.filter(x => x.id != announcement.id)
                      localStorage.setItem('announcements_pop', JSON.stringify(announcementList))
                    } else {
                      seenStatus = announcementListFilter[0].seen == 1 ? 1 : 0;
                    }
                  }
                }
                announcementPop.push({
                  content: announcement.content,
                  id: announcement.id,
                  code: announcement.code,
                  location_name: announcement.location_name,
                  seen: seenStatus,
                  settings_locale_id: announcement.settings_locale_id,
                  always_pop: announcement.always_pop,
                });
              }
            } else {
              if (announcement.session == 1 || announcement.session == 2) {
                let seenStatus = 0;
                if (localStorage.getItem('announcements_pop') !== undefined && localStorage.getItem('announcements_pop') !== null) {
                  let announcementList = JSON.parse(localStorage.getItem('announcements_pop'))
                  let announcementListFilter = announcementList.filter(x => x.id == announcement.id)
                  if (announcementListFilter.length > 0) {
                    if (announcementListFilter[0].always_pop == 0) {
                      announcementList = announcementList.filter(x => x.id != announcement.id)
                      localStorage.setItem('announcements_pop', JSON.stringify(announcementList))
                    } else {
                      seenStatus = announcementListFilter[0].seen == 1 ? 1 : 0;
                    }
                  }
                }
                announcementPop.push({
                  content: announcement.content,
                  id: announcement.id,
                  code: announcement.code,
                  location_name: announcement.location_name,
                  seen: seenStatus,
                  settings_locale_id: announcement.settings_locale_id,
                  always_pop: announcement.always_pop,
                });
              }
            }
          }
        });

        if (announcementPop.length > 0) {
          const popUpAnnouncementsFromLocal = localStorage.getItem('announcements_pop');
          if (popUpAnnouncementsFromLocal === null || JSON.parse(popUpAnnouncementsFromLocal).length === 0) {
            if (dialogCode) {
              announcementPop.forEach(function (item, i) {
                if (item['code'] == dialogCode) {
                  announcementPop.splice(i, 1);
                  announcementPop.unshift(item);
                }
              });
            }
            localStorage.setItem('announcements_pop', JSON.stringify(announcementPop));
            this.eventEmitterService.onSwalAnnouncementEmitter(page);
            this.onSwalFire(this.page, JSON.stringify(announcementPop), websocketPop);
          } else {
            if (JSON.stringify(announcementPop) !== JSON.stringify(this.setOldAnnouncements(popUpAnnouncementsFromLocal))) { // if the announcement list update on BO this would update the list on storage
              const updatedPopUpAnnouncements = this.mergeAllAnnouncements(announcementPop.concat(JSON.parse(popUpAnnouncementsFromLocal)));
              const finalPopUpAnnouncement = this.setFinalAnnouncement(updatedPopUpAnnouncements);
              if (dialogCode) {
                finalPopUpAnnouncement.forEach(function (item, i) {
                  if (item['code'] == dialogCode) {
                    finalPopUpAnnouncement.splice(i, 1);
                    finalPopUpAnnouncement.unshift(item);
                  }
                });
              }
              localStorage.setItem('announcements_pop', JSON.stringify(finalPopUpAnnouncement));
              this.onSwalFire(this.page, JSON.stringify(finalPopUpAnnouncement), websocketPop);
            } else {
              this.onSwalFire(this.page, popUpAnnouncementsFromLocal, websocketPop);
            }
          }
        } else {
          localStorage.removeItem('announcements_pop');
        }
      });
    });

    let hasMarquee = false;
    let hasMaintenance = false;

    // General Annoucements 
    const marqueesList: any[] = [];
    this.announcementHttpService.getMarquees().subscribe(res => {
      res.forEach((marquee: any) => {
        const loggedIn = localStorage.getItem('user_data') != null;
        if (loggedIn) {
          if (marquee.session === 1 || marquee.session === 3) {
            marqueesList.push(marquee);
          }
        } else {
          if (marquee.session === 1 || marquee.session === 2) {
            marqueesList.push(marquee);
          }
        }
      });

      if (marqueesList.length > 0) {
        hasMarquee = true;
        const localMarquees = localStorage.getItem('marquees');
        if (!localMarquees || JSON.stringify(marqueesList) !== localMarquees) {
          localStorage.setItem('marquees', JSON.stringify(marqueesList));
        }
      } else {
        localStorage.removeItem('marquees');
      }

      this.eventEmitterService.onMarqueesEmitter();
    });

    // Maintenance Annoucements
    const maintenancesList: any[] = [];
    this.announcementHttpService.getMaintenances().subscribe(res => {
      res.forEach(m => maintenancesList.push(m));

      if (maintenancesList.length > 0) {
        hasMaintenance = true;
        const localMaintenances = localStorage.getItem('maintenances');
        if (!localMaintenances || JSON.stringify(maintenancesList) !== localMaintenances) {
          localStorage.setItem('maintenances', JSON.stringify(maintenancesList));
        }
      } else {
        localStorage.removeItem('maintenances');
      }

      this.eventEmitterService.onMarqueesEmitter();
    });
  }

  onSwalFire(page: string, announcementPop?: any, websocketPop = false) {
    var currentURL = window.location.pathname.split('/');
    let Current_page = 'home';
    if (currentURL && this.currentURL.length > 1) {
      const result = currentURL.find(value => this.dialogLocation.some(item => item.name.toLowerCase() === value.toLowerCase().replace('wallet;tab=', ''))) || 'home';
      Current_page = result.replace('wallet;tab=', '').replace('forgot-password;tab=', '');
    }

    this.announcements$ = [];
    this.announcementIds = [];
    if (announcementPop !== undefined) {
      localStorage.removeItem('popup_ids');
      JSON.parse(announcementPop).map(announcement => {
        if ((announcement.location_name === Current_page || announcement.location_name === 'all') && announcement.seen === 0 && Current_page !== 'landing' && window.location.pathname !== 'gamelaunch' && window.location.pathname !== '/launch-game') {
          this.announcements$.push(announcement.content);
          this.announcementIds.push(announcement.id);
        }
      });
      this.cdr.markForCheck();
      localStorage.setItem('popup_ids', JSON.stringify(this.announcementIds));

      if (websocketPop) {
        this.eventEmitterService.swalAnnouncementEmitter.emit(Current_page);
      }
    }
  }

  private checkVersionNew() {
    //const currentVersion = localStorage.getItem('version');
    localStorage.setItem('version', version);
    // if ((currentVersion != null && version != currentVersion) || currentVersion == null) {
    //   localStorage.clear();
    //   sessionStorage.clear();
    //   localStorage.setItem('version', version);
    //   if (window.location.pathname !== '/') {
    //     window.location.href = '/';
    //   }
    // }
  }

  private setFinalAnnouncement(updatedPopUpAnnouncements: any) { // set the final announcement before push to localstorage
    const finalPopUp = [];
    updatedPopUpAnnouncements.map((result: any) => {
      finalPopUp.push({
        ...result,
        content: result.content[0],
        location_name: result.location_name[0],
        seen: (result.settings_locale_id[0] !== result.settings_locale_id[1] || result.location_name[0] !== result.location_name[1]
          || result.content[0] !== result.content[1]) && (result.seen[0] !== result.seen[1]) ? result.seen[0] : result.seen[1],
        settings_locale_id: result.settings_locale_id[0]
      });
    });
    return finalPopUp;
  }

  private setOldAnnouncements(announcements: any) { // update localstorage seen to 0
    const popUp = [];
    JSON.parse(announcements).map(res => {
      popUp.push({
        ...res,
        seen: 0
      });
    });
    return popUp;
  }

  private mergeAllAnnouncements(allAnnouncement: any) { // merge all data but unique id
    const updatedPopUpAnnouncements = [];
    allAnnouncement.map(allAnn => {
      const existing = updatedPopUpAnnouncements.filter((v, i) => {
        return v.id === allAnn.id;
      });
      if (existing.length) {
        const existingIndex = updatedPopUpAnnouncements.indexOf(existing[0]);
        updatedPopUpAnnouncements[existingIndex].content = updatedPopUpAnnouncements[existingIndex].content.concat(allAnn.content);
        updatedPopUpAnnouncements[existingIndex].location_name = updatedPopUpAnnouncements[existingIndex].location_name.concat(allAnn.location_name);
        updatedPopUpAnnouncements[existingIndex].seen = updatedPopUpAnnouncements[existingIndex].seen.concat(allAnn.seen);
        updatedPopUpAnnouncements[existingIndex].settings_locale_id = updatedPopUpAnnouncements[existingIndex].settings_locale_id.concat(allAnn.settings_locale_id);
      } else {
        allAnn.content = [allAnn.content];
        allAnn.location_name = [allAnn.location_name];
        allAnn.seen = [allAnn.seen];
        allAnn.settings_locale_id = [allAnn.settings_locale_id];
        updatedPopUpAnnouncements.push(allAnn);
      }
    });
    return updatedPopUpAnnouncements;
  }

  onClose() {
    this.router.navigate(['/']);
  }

  show() {
    if (this.router.url == '/unsupported-country') {
      return false;
    } else {
      return true;
    }
  }

  onBackButtonClick() {
    this.location.back();
  }

  onActivate() {
    document.body.scrollTop = 0;
  }

  isUserLoggedIn() {
    return this.authService.isUserLoggedIn;
  }

  private onRewardNotice() {
    this.dialog.open(RewardSwalComponent, {
      width: '800px',
      data: {
        type: 'notice'
      }
    });
  }

  private browserInit() {
    try {
      const languages = this.supportedCountry[this.currentDomain][localStorage.getItem('country_code')]['languages'];
      if (!languages.includes(localStorage.getItem('language_code').toUpperCase())) {
        localStorage.setItem('language_code', languages[0])
        this.translateService.use(languages[0].toLocaleLowerCase());
      }
    } catch (e) { }

    if (this.deviceDetectorService.isDesktop()) {
      let desktopPreExt = null;
      let fullDomain = '';

      // Get the desktop pre extension for the country
      try {
        Object.keys(this.supportedCountry[this.currentDomain]).forEach(key => {
          if (this.supportedCountry[this.currentDomain][key][environment.domainEnv].includes(this.hostname)) {
            desktopPreExt = this.supportedCountry[this.currentDomain][key]['desktopPreExt'][environment.domainEnv];
            throw {};
          }
        })
      } catch (e) { }

      // Append full domain
      if (desktopPreExt === null) {
        fullDomain = (environment.https ? 'https://' : 'http://') + environment.domainName;
      } else {
        fullDomain = (environment.https ? 'https://' : 'http://') + desktopPreExt + this.hostname;
      }
      this.isDesktopDetected = true;
      const marketingParams = this.authService.getUrlParams(window.location.search);
      let authSuffix = '';
      let crossLoginParam = '';
      let countryLanguageParam = '';
      if (((window.location.pathname).startsWith('/signup') || (window.location.pathname).startsWith('/login')) && Object.keys(marketingParams)) {
        authSuffix = `${(window.location.pathname).startsWith('/login') ? '/login?' : '/signup?'}${Object.keys(marketingParams).map(key => key + '=' + marketingParams[key]).join('&')}`;
      }
      // Begin:: Cross device login
      if (!(window.location.pathname).startsWith('/login') && localStorage.getItem('user_token') && localStorage.getItem('user_data')) {
        crossLoginParam = (authSuffix === '' ? '?' : '&') + `userToken=${localStorage.getItem('user_token')}&userData=${localStorage.getItem('user_data')}`;
      }
      // End:: Cross device login
      countryLanguageParam = ((authSuffix.includes('?') || crossLoginParam.includes('?')) ? '&lang=' : '?lang=') + ((localStorage.getItem('country_code') ?? 'MY') + '_' + (localStorage.getItem('language_code') ?? 'EN'))
      window.location.href = fullDomain + authSuffix + crossLoginParam + countryLanguageParam;
    }

    localStorage.setItem('sessionid_tracker', (+new Date()).toString(16).toUpperCase());
  }

  private getRouteTitle(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (((this.backButtonList.includes(this.router.url) || this.router.url.includes('/member')) && this.router.url !== '/member/account' && this.router.url !== '/member/wallet') || this.router.url.includes('/promotion/')) {
      this.showBackButton = true;
    } else {
      this.showBackButton = false;
    }

    if (activatedRoute.firstChild) {
      return this.getRouteTitle(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  // This function is to check whether should navigate to landing page
  private landingPage() {
    let countryCode = localStorage.getItem('country_code') ? localStorage.getItem('country_code') : null;
    this.countryCode = countryCode;
    Object.keys(this.supportedCountry[this.currentDomain]).forEach(key => {
      this.supportedCountry[this.currentDomain][key][environment.domainEnv].forEach(domain => {
        if ((this.supportedCountry[this.currentDomain][key]['mobilePreExt'][environment.domainEnv] + domain) == window.location.hostname) {
          countryCode = key;
        }
      });
      // if (this.supportedCountry[this.currentDomain][key][environment.domainEnv].includes(this.hostname)) {
      //   countryCode = key;
      // }
    })

    // Go landing page
    if (
      this.hostname !== 'localhost' &&
      (environment.production && !this.hiddenDomains.includes(this.hostname)) &&
      (
        countryCode === null ||
        environment.domainName.split('|').includes(this.hostname) ||
        environment.altDomainName.split('|').includes(this.hostname) ||
        environment.altDomainNameTwo.split('|').includes(this.hostname) ||
        this.checkMobileDomain(countryCode)
      )
    ) {
      this.router.navigateByUrl('/landing', {
        replaceUrl: true,
        skipLocationChange: false
      });
    }
    // Not going to landing page
    else {
      const urlParams = new URLSearchParams(window.location.search);

      // If got param, this param is pass from landing page
      if (urlParams.get('lang') !== null) {
        // E.g MY_EN
        const countryAndLanguage = urlParams.get('lang').split('_');
        localStorage.setItem('country_code', countryAndLanguage[0]);
        localStorage.setItem('language_code', countryAndLanguage[1]);
        this.translateService.use(countryAndLanguage[1].toLocaleLowerCase());
      }
      // No param
      else {
        // Production & demo env
        if (environment.production || environment.domainEnv == 'demo') {
          // MY_EN by default for VIP Hidden Domains
          if (this.hiddenDomains.includes(this.hostname)) {
            // Set to default value if null
            if(localStorage.getItem('country_code') === null){
              let defaultcountryCode = this.audSite.includes(this.currentProjectCode) ? 'AU' : 'MY'; // Default
              localStorage.setItem('country_code', defaultcountryCode);
            }
            if (localStorage.getItem('language_code') === null) {
              localStorage.setItem('language_code', "EN"); // Set to default value if null
              this.translateService.use('en');
            }
          } else {
            // Set to default value if null
            if(localStorage.getItem('country_code') === null){
              let defaultcountryCode = this.audSite.includes(this.currentProjectCode) ? 'AU' : 'MY'; // Default
              localStorage.setItem('country_code', defaultcountryCode);
            }
            let languageCode = countryCode === 'ID' ? 'ID' : 'EN'; // EN by default for all country except for Indonesia

            if (localStorage.getItem('language_code') === null) {
              localStorage.setItem('language_code', languageCode);
              this.translateService.use(languageCode.toLocaleLowerCase());
            }
          }
        }
        // LocalHost or Staging
        else if (this.hostname === 'localhost' || !environment.production) {
          // Set to default value if null
          if(localStorage.getItem('country_code') === null){
              let defaultcountryCode = this.audSite.includes(this.currentProjectCode) ? 'AU' : 'MY'; // Default
              localStorage.setItem('country_code', defaultcountryCode);
          }
          if (localStorage.getItem('language_code') === null) {
            localStorage.setItem('language_code', "EN"); // Set to default value if null
            this.translateService.use('en');
          }
        }
      }

      // Auto login part
      if (urlParams.get('userToken')) {
        const userToken = urlParams.get('userToken');

        try {
          const parsedToken = JSON.parse(decodeURIComponent(userToken));
          localStorage.setItem('user_token', JSON.stringify(parsedToken));

          this.portalMemberProfileHttpService.getAll().subscribe({
            next: (profileData) => {
              localStorage.setItem('user_data', JSON.stringify(profileData['rows']));

              // timeout to ensure the localStorage is updated before redirecting, can set to lower depending on how fast server is
              setTimeout(() => {
                window.location.href = location.href.split('?')[0];
              }, 3000); 
            },
            error: (err) => {
              console.error('Failed to load profile:', err);
            }
          });
        } catch (err) {
          console.error('Invalid userToken format:', err);
        }
      }
    }
  }

  private onVerifyEmail() {
    if (window.location.pathname === '/verify-email') {
      if (window.location.search === '') {
        window.location.assign(''); // need to reload to get the latest top bar title
      } else {
        if (window.location.search.split('?token=')[1] === '') {
          window.location.assign(''); // need to reload to get the latest top bar title
        } else {
          this.loadingBar.start();
          this.emailVerificationHttpService.verify({ token: window.location.search.split('?token=')[1] }).pipe(
            tap((res: any) => {
              localStorage.setItem('verify_email_message', JSON.stringify(res));
              this.afterOnVerification();
              this.loadingBar.complete();
            })
          ).subscribe();
        }
      }
    }
  }

  private getHostname() {
    // E.g: localhost.com
    // Get localhost.com
    if (this.hostname.includes('-vip.jk188.net')) {
      this.hostname = this.hostname.substr(this.hostname.indexOf('.') - 4);
    } else {
      if (this.hostname.split('.').length > 2) {
        this.hostname = this.hostname.substr(this.hostname.indexOf('.') + 1);
      }
    }

    // Main
    if (
      JSON.stringify(this.supportedCountry[environment.domainName]).includes('"' + this.hostname + '"') ||
      environment.domainName.split('|').includes(this.hostname)
    ) {
      sessionStorage.removeItem('mainDomainBlocked');
      this.mainDomainBlocked = false;
      this.currentDomain = environment.domainName;
    }
    // First Alternative
    else if (
      JSON.stringify(this.supportedCountry[environment.altDomainName]).includes('"' + this.hostname + '"') ||
      environment.altDomainName.split('|').includes(this.hostname)
    ) {
      sessionStorage.setItem('mainDomainBlocked', 'true');
      this.mainDomainBlocked = true;
      this.currentDomain = environment.altDomainName;
    }
    // Second Alternative
    else if (
      JSON.stringify(this.supportedCountry[environment.altDomainNameTwo]).includes('"' + this.hostname + '"') ||
      environment.altDomainNameTwo.split('|').includes(this.hostname)
    ) {
      sessionStorage.setItem('mainDomainBlocked', 'true');
      this.mainDomainBlocked = true;
      this.currentDomain = environment.altDomainNameTwo;
    } else {
      sessionStorage.removeItem('mainDomainBlocked');
      this.mainDomainBlocked = false;
      this.currentDomain = environment.domainName;
    }
  }

  private getLiveChatScript() {
    const language = localStorage.getItem('language_code') || '';
    const country = localStorage.getItem('country_code') || '';
    const memberGroupCode = localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data'))?.member_group?.code?.toLowerCase() || '' : '';
    const storedLiveChat = this.livechatHttpService.getLiveChatScriptFromSession();
    const storedMemberGroups: string[] = storedLiveChat?.member_groups || [];

    // Check if the stored script exists or if the language/country has changed
    const hasLocaleChanged = !storedLiveChat ||
      storedLiveChat.language_code !== language ||
      storedLiveChat.country_code !== country;

    // Check if current member group exist in stored live chat member group 
    let memberGroupExists = false;
    if (memberGroupCode == '') {
      // If user not logged-in, check for 'NORMAL' member group live chat
      memberGroupExists = storedMemberGroups.some(group => group.toLowerCase() === 'normal');
    } else {
      memberGroupExists = storedMemberGroups.some(group => group.toLowerCase() === memberGroupCode);
    }

    if (!hasLocaleChanged && memberGroupExists) {
      this.loadChatScript(storedLiveChat);
    } else {
      this.livechatHttpService.getLiveChatScript(`?language=${language}&country=${country}&member_group_code=${memberGroupCode}`).subscribe();
    }

    // Start WebSocket listener for script updates
    this.livechatHttpService.liveChatScriptWebsocket();
  }

  private loadChatScript(liveChat: Livechat) {
    var liveChatScriptID = "live-chat-script";

    const removeOldLiveChat = () => {
      const scriptElement = document.getElementById(liveChatScriptID);
      if (scriptElement?.parentNode) {
        scriptElement.parentNode.removeChild(scriptElement);
      }

      // Remove any <noscript> related to LiveChat
      const noscripts = document.querySelectorAll('noscript');
      noscripts.forEach((noscript) => {
        if (noscript.innerHTML.includes('livechat.com') && noscript.parentNode) {
          noscript.parentNode.removeChild(noscript);
        }
      });

      // Call destroy widget
      if (window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function') {
        try {
          window.LiveChatWidget.call('destroy');
        } catch (e) {
        }
      }
    };

    var scriptExists = (document.getElementById(liveChatScriptID) !== null);
    // Remove old live chat <script> if already exists.
    if (scriptExists) {
      removeOldLiveChat();
    }

    if (liveChat.website !== null && liveChat.website !== '') {
      this.isLoggedIn$.subscribe(login => {
        var website = liveChat.website;
        if (!website.includes(`id="${liveChatScriptID}"`)) {
          var scriptIndex = website.indexOf('<script') + '<script'.length;
          website = website.slice(0, scriptIndex) + ' id="' + liveChatScriptID + '" ' + website.slice(scriptIndex, website.length);
        }

        if (this.livechatHttpService.getLiveChatScriptFromSession('live_chat_platform_name') == 'Live Chat') {
          // website = website.replace(/(['])/g, "\\$1");
          var index = website.indexOf('window.__lc.license');
          var username = "  ";
          var email = "  ";

          if (login) {
            if (localStorage.getItem('user_data') != null) {
              if (JSON.parse(localStorage.getItem('user_data')).username != null && JSON.parse(localStorage.getItem('user_data')).username !== '') {
                username = JSON.parse(localStorage.getItem('user_data')).username;
              }
              if (JSON.parse(localStorage.getItem('user_data')).email != null && JSON.parse(localStorage.getItem('user_data')).email !== '') {
                email = JSON.parse(localStorage.getItem('user_data')).email;
              }
            }

            const visitorScript = `window.__lc.visitor = {name: '${username}', email: '${email}'};`;
            if (website.includes('window.__lc.visitor')) {
              website = website.replace(/window\.__lc\.visitor\s*=\s*\{[^}]*\};?/g, visitorScript);
            } else if (website.includes('window.__lc.license')) {
              const index = website.indexOf('window.__lc.license');
              website = website.slice(0, index) + visitorScript + website.slice(index);
            }
          }
          else {
            if (index > 0) {
              website = website.slice(0, index) + website.slice(index, website.length);
            }
          }

          $(website).appendTo(document.body);
          this.setLiveChatCustomVariable();
        } else if (this.livechatHttpService.getLiveChatScriptFromSession('live_chat_platform_name') == 'Crisp') {

          // Crisp no need to remove and assign again due to after assign it require refresh only can work.
          if (!scriptExists || typeof window.$crisp === "undefined") {
            $(website).appendTo(document.body);
            var indexStart = website.indexOf('window.CRISP_WEBSITE_ID=') + 'window.CRISP_WEBSITE_ID='.length;
            var indexEnd = website.indexOf(';(function(){d=document');
            var websiteID = website.slice(indexStart, indexEnd).replace(/\\/g, "").replace(/\"/g, "");

            Crisp.configure(websiteID);
          }

          if (login) {
            if (localStorage.getItem('user_data') != null) {
              if (JSON.parse(localStorage.getItem('user_data')).username != null && JSON.parse(localStorage.getItem('user_data')).username !== '') {
                Crisp.user.setNickname(JSON.parse(localStorage.getItem('user_data')).username);
              }
              if (JSON.parse(localStorage.getItem('user_data')).email != null && JSON.parse(localStorage.getItem('user_data')).email !== '') {
                Crisp.user.setEmail(JSON.parse(localStorage.getItem('user_data')).email);
              }
            }
          }

        }
        this.livechatHttpService.updateLiveChatScriptInSession('website', website);
      });
    }
  }

  private setLiveChatCustomVariable() {
    this.isLoggedIn$.subscribe(res => {
      if (res) {
        setTimeout(async () => {
          const liveChatTranslate = this.liveChatHttpService.getTranslation();
          const apiParams = [];

          if (!this.liveChatHttpService.getInfoOngoing) {
            const cookieData = this.liveChatHttpService.getLiveChatInfoCookies();
            if (!cookieData['username']) { apiParams.push('username'); }
            if (!cookieData['membership']) { apiParams.push('membership'); }
            if (!cookieData['balance']) { apiParams.push('balance'); }
            if (!cookieData['last_played_game']) { apiParams.push('last_played_game'); }
            if (!cookieData['kyc_status']) { apiParams.push('kyc_status'); }
            if (!cookieData['next_required_deposit']) { apiParams.push('next_required_deposit'); }
            if (apiParams.length > 0) {
              this.liveChatHttpService.getLiveChatInfo(apiParams).subscribe(apiData => {
                const mergedData = { ...cookieData, ...apiData };
                const lcCustomVariables = Object.keys(mergedData).reduce((acc, key) => {
                  acc[liveChatTranslate[key]] = mergedData[key];
                  return acc;
                }, {});
                window.LiveChatWidget.call('set_session_variables', lcCustomVariables);
              });
            } else {
              const lcCustomVariables = Object.keys(cookieData).reduce((acc, key) => {
                acc[liveChatTranslate[key]] = cookieData[key];
                return acc;
              }, {});
              window.LiveChatWidget.call('set_session_variables', lcCustomVariables);
            }
          }
        }, 500)
      }
    });
  }

  private getCleanModeLiveChatScript() {
    if (this.mode !== 'Members Only' || this.isUserLoggedIn()) {
      return;
    }

    const language = localStorage.getItem('language_code');
    const country = localStorage.getItem('country_code');
    const countryLang = `${country}_${language}`;
    const groupIds = {
      MY_EN: 54,
      MY_ZH: 55,
      SG_EN: 56,
      SG_ZH: 57
    };

    const chatParentElem = document.createElement('div');
    chatParentElem.id = "clean-mode-live-chat-widget";
    const script = document.createElement('script');
    const noscript = document.createElement('noscript');
    script.innerHTML = `
      window.__lc = window.__lc || {};
      window.__lc.license = 10515072;
      window.__lc.group = ${groupIds[countryLang] || 54};
      ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
    `;
    noscript.innerHTML = '<a href="https://www.livechat.com/chat-with/10515072/" rel="nofollow">Chat with us</a>, powered by <a href="https://www.livechat.com/?welcome" rel="noopener nofollow" target="_blank">LiveChat</a>';
    chatParentElem.appendChild(script);
    chatParentElem.appendChild(noscript);
    document.body.append(chatParentElem);
  }

  private async checkLocation() {
    const pathname = window.location.pathname,
      countryCode = localStorage.getItem('country_code');
    this.countryCode = localStorage.getItem('country_code');
    if (
      window.mode != 'Members Only' &&
      (environment.production || environment.domainEnv == 'demo') &&
      (countryCode in this.supportedCountry[this.currentDomain]) &&
      pathname !== '/landing' &&
      this.hostname !== 'localhost' &&
      !environment.domainName.split('|').includes(this.hostname) &&
      !environment.altDomainName.split('|').includes(this.hostname) &&
      !environment.altDomainNameTwo.split('|').includes(this.hostname) &&
      this.supportedCountry[this.currentDomain][countryCode][environment.domainEnv].includes(this.hostname)
    ) {
      // THIS PART COMMENTED BECAUSE DONT WANT TO USE COORDINATES (GEO-LOCATION) TO GET USER LOCATION, geoLocationError FUNCTION IS USE IP ADDRESS TO GET USER LOCATION
      // if (navigator.geolocation) {
      //   const position = await this.getCoordinates();
      //   if (position['coords']) {
      //     this.geoLocationSuccess(position);
      //   } else {
      //     this.geoLocationError();
      //   }
      // } else {
      this.geoLocationError();
      // }
    } else if (
      (environment.production || environment.domainEnv == 'demo') &&
      pathname !== '/landing' &&
      !environment.domainName.split('|').includes(this.hostname) &&
      !environment.altDomainName.split('|').includes(this.hostname) &&
      !environment.altDomainNameTwo.split('|').includes(this.hostname)
    ) {
      this.isLoggedIn$.subscribe(res => {
        if (!JSON.stringify(this.supportedCountry[this.currentDomain]).includes('"' + this.hostname + '"') && !res) {
          this.alertCountryNotSupported();
        }
      });
    }
  }

  onLoginVerificationPop() {
    this.bankAccountDataService.getUnseenVerificationRecords().pipe(
      tap(res => {
        if (res.length > 0) {
          res.forEach((item) => {
            if (item.verification_settings_field.length > 0) {
              if (item.status == 1) {
                this.onOpenVerificationDialog(EwalletVerificationApprovalComponent, item, true);
              } else if (item.status == 2) {
                this.onOpenVerificationDialog(EwalletVerificationRejectionComponent, item, true);
              }
            }
          })
        }
      })
    ).subscribe();
  }

  ewalletVerificationPop() {
    this.newRequestIncoming.subscribe(() => {
      this.verificationData = EwalletVerificationHttpService.verification;
      if (this.verificationData) {
        if (this.verificationData.status == 1) {
          this.onOpenVerificationDialog(EwalletVerificationApprovalComponent, this.verificationData, false);
        } else if (this.verificationData.status == 2) {
          this.onOpenVerificationDialog(EwalletVerificationRejectionComponent, this.verificationData, false);
        }
      }
    })
  }

  onOpenVerificationDialog(componentRef: any, verificationData: any, loginPop: boolean) {
    var bank_id = loginPop == true ? verificationData.id : verificationData.member_bank_account_id;
    var dialogRef = this.dialog.open(componentRef, {
      width: 'auto',
      data: {
        bankAccountId: bank_id,
        bank_name: verificationData.bank_name,
        account_number: verificationData.account_number,
        reason: verificationData.reason,
        verificationSetting: verificationData,
        bankVerificationStatus: verificationData.status
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.eventEmitterService.onUpdateBankList();
      this.eventEmitterService.onReloadBankList();
      if (verificationData.status == 2 || verificationData.status == 4) {
        this.eventEmitterService.onUpdateVerificationEmitter();
      }
      this.bankAccountDataService.updateVerificationSeen(bank_id).pipe().subscribe();
    });
  }

  private getCoordinates() {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, resolve, { timeout: 5000 });
    });
  }

  private geoLocationSuccess(position) {
    const getCountryISO2 = countryISOMapping;
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    this.locationHttpService.getByCoordinates(longitude, latitude).subscribe(res => {
      const iso2CountryCode = getCountryISO2(res.CountryCode)
      if (iso2CountryCode != localStorage.getItem('country_code') && (iso2CountryCode in this.supportedCountry[this.currentDomain])) {
        this.showChangeCountryNotice = true;
        this.countryCodeToChange = iso2CountryCode;
        localStorage.setItem('countryNotice', '1')
      }
    })
  }

  private geoLocationError() {
    this.locationHttpService.getIpAddress().subscribe(res => {
      if (res['country_code']) {
        this.geolocationChange(res['country_code'].toUpperCase());
      } else {
        const xhr = new XMLHttpRequest();
        const url = `https://geolocation-db.com/json/${res['ip']}`;
        xhr.open('GET', url);
        xhr.send();
        xhr.onloadend = () => {
          if (xhr.response) {
            const address = JSON.parse(xhr.response);
            this.geolocationChange(address.country_code.toUpperCase());
          }
        }
      }
    })
  }

  private geolocationChange(country_code: string) {
    if (country_code != localStorage.getItem('country_code') && country_code in this.supportedCountry[this.currentDomain]) {
      this.showChangeCountryNotice = true;
      localStorage.setItem('countryNotice', '1');
      this.countryCodeToChange = country_code;
      this.countryCode = country_code;
      localStorage.setItem('countryNotice', '1')
    }
  }

  onChangeCountrySite() {
    var urlParams = new URLSearchParams(window.location.search), lang: string = this.countryCodeToChange.toUpperCase() + '_';
    urlParams.delete('lang');
    if (this.countryCodeToChange.toUpperCase() == 'ID') {
      lang += 'ID';
    } else if (this.countryCodeToChange.toUpperCase() == 'TH') {
      lang += 'TH';
    } else {
      lang += this.supportedCountry[this.currentDomain][this.countryCodeToChange.toUpperCase()]['languages'][0];
    }
    urlParams.append('lang', lang);
    window.location.assign((environment.https ? 'https://' : 'http://') + window.location.hostname + window.location.pathname + '?' + urlParams.toString());
  }

  onChangeCountryStatus() {
    this.showChangeCountryNotice = false;
    localStorage.setItem('countryNotice', (this.showChangeCountryNotice) ? '1' : '0');
    this.eventEmitterService.onCountryNotice();

  }

  private afterOnVerification() {
    this.isLoggedIn$.subscribe(res => {
      if (res) {
        window.location.assign('/member/profile'); // need to reload to get the latest top bar title
      } else {
        window.location.assign(''); // need to reload to get the latest top bar title
      }
    });
  }

  private alertCountryNotSupported() {
    var url = (environment.https ? 'https://' : 'http://') + environment.mobileDomainName;
    // Direct redirect to landing page
    window.location.assign(url + '/landing');
  }

  private redirectToS3Link() {
    if (this.s3RedirectURL[this.pathName]) {
      var redirectURL = this.s3RedirectURL[this.pathName] + '';
      var countryCode = localStorage.getItem('country_code');
      var languageCode = this.pathName.substr(1, 2);
      redirectURL = redirectURL.replace('#COUNTRY_LANGUAGE', countryCode + '_' + languageCode);
      window.location.href = redirectURL;
    }
  }

  private checkMobileDomain(countryCode: string) {
    if (countryCode != null) {
      let availableMobileDomain = [],
        mobilePreExt = this.supportedCountry[this.currentDomain][countryCode].mobilePreExt[environment.domainEnv],
        hostname = window.location.hostname;
      this.supportedCountry[this.currentDomain][countryCode][environment.domainEnv].forEach(item => {
        availableMobileDomain.push(mobilePreExt + item);
      });
      return !availableMobileDomain.includes(hostname);
    }
    return true;
  }

  private checkReminder() {
    if (!this.shutdownflag && environment.sitePrefix == 'bp9') {
      this.newLink = window.location.hostname;//this.supportedCountry[this.currentDomain][localStorage.getItem('country_code')][environment.domainEnv][0];
      let doNotShowAgain = localStorage.getItem('showReminder');
      if (this.mode != 'Members Only' && (doNotShowAgain == null || doNotShowAgain == 'true')) {
        this.showReminder = true;
        localStorage.setItem('showReminder', 'true');
      } else {
        this.showReminder = false;
      }
    }
  }

  onDoNotShowAgain() {
    localStorage.setItem('showReminder', 'false');
    this.showReminder = false;
  }

  onRTP() {
    window.location.href = 'https://rtp.bp9.xyz';
  }

  checkLivechat() {

    if (((document.getElementsByClassName('livechat') && document.getElementsByClassName('livechat').length > 0))
      || (document.getElementById('chat-widget-container'))) {
      return 'liveChat';
    }
    if ((document.getElementsByClassName('sb-chat') && document.getElementsByClassName('sb-chat').length > 0)) {
      return 'sbChat';
    }
    return false;
  }

  ppChallengePhase1ResultPop() {
    this.ppPhase1ResultIncoming.subscribe(() => {
      this.phase1ResData = PPChallengePromotionHttpService.phase1Res;
      if (this.phase1ResData) {
        this.activePPChallengePromo.p1ResPopSeen = false;

        if (this.phase1ResData.phase1_promo_status == 1) {
          this.activePPChallengePromo.p2MemberPromotionID = this.phase1ResData.phase2_member_promotion_id;
          this.activePPChallengePromo.p2PopSeen = false;
          this.activePPChallengePromo.p2BonusAmount = this.phase1ResData.phase2_bonus_amount;
          this.activePPChallengePromo.p2TargetAmount = this.phase1ResData.phase2_target_amount;
          this.activePPChallengePromo.p2TargetType = this.phase1ResData.phase2_target_type;
        }
        console.log(this.activePPChallengePromo);
        localStorage.setItem('activePPChallengePromo', JSON.stringify(this.activePPChallengePromo));
        this.onOpenPPChallengePhase1ResultDialog(PromotionDialogComponent, this.phase1ResData);
      }
    })
  }

  onLoginPPChallengePop() {
    this.ppChallengePromotionHttpService.getActivePPChallengeRes().pipe(
      tap(res => {
        if (!res) return;

        let shouldOpenDialog = false;

        // Unseen P1 dialog & member promotion's status is active 
        if (res.p1_seen == 0 && res.status == 1) {
          this.activePPChallengePromo.activeP1Promo = true;
          this.activePPChallengePromo.p1PopSeen = false;
          this.activePPChallengePromo.p1TargetAmount = res.target_amount;
          this.activePPChallengePromo.p1MemberPromotionID = res.member_promotion_id;
          this.activePPChallengePromo.freeSpinGameCode = res.free_spin_game_code;
          this.activePPChallengePromo.p1PromotionID = res.promotion_id;

          shouldOpenDialog = false;
        }
        // Unseen P1 result dialog & member promotion's status is completed 
        else if (res.p1_seen == 1 && res.p1_result_seen == 0 && res.status == 3) {
          this.activePPChallengePromo.activeP1Promo = true;
          this.activePPChallengePromo.p1PopSeen = true;
          this.activePPChallengePromo.p1ResPopSeen = false;
          this.activePPChallengePromo.p1TargetAmount = res.target_amount;
          this.activePPChallengePromo.p1MemberPromotionID = res.member_promotion_id;

          if (res.phase1_promo_status == 1) {
            this.activePPChallengePromo.p2MemberPromotionID = res.phase2_member_promotion_id;
            this.activePPChallengePromo.p2PopSeen = false;
            this.activePPChallengePromo.p2BonusAmount = res.phase2_bonus_amount;
            this.activePPChallengePromo.p2TargetAmount = res.phase2_target_amount;
            this.activePPChallengePromo.p2TargetType = res.phase2_target_type;
          }
          
          shouldOpenDialog = true;
        } 
        // If member have p2 active promo but unseen p2 dialog
        else if (res.p1_seen == 1 && res.p1_result_seen == 1 && res.phase2_seen == 0) {
          this.activePPChallengePromo.activeP1Promo = true;
          this.activePPChallengePromo.p1PopSeen = true;
          this.activePPChallengePromo.p1ResPopSeen = true;
          this.activePPChallengePromo.p2PopSeen = false;
          this.activePPChallengePromo.p1TargetAmount = res.target_amount;
          this.activePPChallengePromo.p2MemberPromotionID = res.phase2_member_promotion_id;
          this.activePPChallengePromo.p2BonusAmount = res.phase2_bonus_amount;
          this.activePPChallengePromo.p2TargetAmount = res.phase2_target_amount;
          this.activePPChallengePromo.p2TargetType = res.phase2_target_type;
          
          shouldOpenDialog = true;
        }
        // If member have p1 active promo and dont have p2 and seen p1 dialog
        else if (res.p1_seen == 1 && res.p1_result_seen == 0 && res.status == 1) {
          this.activePPChallengePromo.activeP1Promo = true;
          this.activePPChallengePromo.p1PopSeen = true;
          this.activePPChallengePromo.p1TargetAmount = res.target_amount;
          this.activePPChallengePromo.p1MemberPromotionID = res.member_promotion_id;

          shouldOpenDialog = false;
        }

        localStorage.setItem('activePPChallengePromo', JSON.stringify(this.activePPChallengePromo));

        if (shouldOpenDialog) {
          this.onOpenPPChallengePhase1ResultDialog(PromotionDialogComponent, res);
        }
      })
    ).subscribe();
  }

  onOpenPPChallengePhase1ResultDialog(componentRef: any, phase1ResData: any) {
    this.dialog.open(componentRef, {
      width: 'auto',
      data: {
        Phase1WinLose: phase1ResData.phase1_promo_status,
        memberPromotionID: phase1ResData.member_promotion_id,
        p1AccumulatedAmount: phase1ResData.accumulated_target_amount,
        PPPhase2: phase1ResData.phase2_target_amount ? true : false
      } 
    });
  }

  btgChallengePhase1ResultPop() {
    this.btgPhase1ResultIncoming.subscribe(() => {
      this.phase1ResData = BTGChallengePromotionHttpService.phase1Res;
      if (this.phase1ResData) {
        this.activeBTGChallengePromo.p1ResPopSeen = false;

        if (this.phase1ResData.phase1_promo_status == 1) {
          this.activeBTGChallengePromo.activeP1Promo = false;
          this.activeBTGChallengePromo.p1PopSeen = true;
          this.activeBTGChallengePromo.p2MemberPromotionID = this.phase1ResData.phase2_member_promotion_id;
          this.activeBTGChallengePromo.p2PopSeen = false;
          this.activeBTGChallengePromo.p2BonusAmount = this.phase1ResData.phase2_bonus_amount;
          this.activeBTGChallengePromo.p2TargetAmount = this.phase1ResData.phase2_target_amount;
        }

        localStorage.setItem('activeBTGChallengePromo', JSON.stringify(this.activeBTGChallengePromo));
        this.onOpenPPChallengePhase1ResultDialog(PromotionDialogComponent, this.phase1ResData);
      }
    })
  }

  onLoginBTGChallengePop() {
    this.btgChallengePromotionHttpService.getActiveBTGChallengeRes().pipe(
      tap(res => {
        if (!res) return;

        let shouldOpenDialog = false;

        // Unseen P1 dialog & member promotion's status is active 
        if (res.p1_seen == 0 && res.status == 1) {
          this.activeBTGChallengePromo.activeP1Promo = true;
          this.activeBTGChallengePromo.p1PopSeen = false;
          this.activeBTGChallengePromo.p1TargetAmount = res.target_amount;
          this.activeBTGChallengePromo.p1MemberPromotionID = res.member_promotion_id;

          shouldOpenDialog = false;
        }
        // Unseen P1 result dialog & member promotion's status is completed 
        else if (res.p1_seen == 1 && res.p1_result_seen == 0 && res.status == 3) {
          this.activeBTGChallengePromo.activeP1Promo = true;
          this.activeBTGChallengePromo.p1PopSeen = true;
          this.activeBTGChallengePromo.p1ResPopSeen = false;
          this.activeBTGChallengePromo.p1TargetAmount = res.target_amount;
          this.activeBTGChallengePromo.p1MemberPromotionID = res.member_promotion_id;

          if (res.phase1_promo_status == 1) {
            this.activeBTGChallengePromo.p2MemberPromotionID = res.phase2_member_promotion_id;
            this.activeBTGChallengePromo.p2PopSeen = false;
            this.activeBTGChallengePromo.p2BonusAmount = res.phase2_bonus_amount;
            this.activeBTGChallengePromo.p2TargetAmount = res.phase2_target_amount;
          }
          
          shouldOpenDialog = true;
        } 
        // If member have p2 active promo but unseen p2 dialog
        else if (res.p1_seen == 1 && res.p1_result_seen == 1 && res.phase2_seen == 0) {
          this.activeBTGChallengePromo.activeP1Promo = true;
          this.activeBTGChallengePromo.p1PopSeen = true;
          this.activeBTGChallengePromo.p1ResPopSeen = true;
          this.activeBTGChallengePromo.p2PopSeen = false;
          this.activeBTGChallengePromo.p1TargetAmount = res.target_amount;
          this.activeBTGChallengePromo.p2MemberPromotionID = res.phase2_member_promotion_id;
          this.activeBTGChallengePromo.p2BonusAmount = res.phase2_bonus_amount;
          this.activeBTGChallengePromo.p2TargetAmount = res.phase2_target_amount;
          
          shouldOpenDialog = true;
        }
        // If member have p1 active promo and dont have p2 and seen p1 dialog
        // else if (res.p1_seen == 1 && res.p1_result_seen == 0 && res.phase2_seen == undefined) {
        //   console.log(4);
        //   this.activePPChallengePromo.activeP1Promo = true;
        //   this.activePPChallengePromo.p1PopSeen = true;
        //   this.activePPChallengePromo.p1TargetAmount = res.target_amount;
        //   this.activePPChallengePromo.p1MemberPromotionID = res.member_promotion_id;

        //   shouldOpenDialog = false;
        // }

        localStorage.setItem('activeBTGChallengePromo', JSON.stringify(this.activeBTGChallengePromo));
        if (shouldOpenDialog) {
          this.onOpenBTGChallengePhase1ResultDialog(PromotionDialogComponent, res);
        }
      })
    ).subscribe();
  }

  onOpenBTGChallengePhase1ResultDialog(componentRef: any, phase1ResData: any) {
    this.dialog.open(componentRef, {
      width: 'auto',
      data: {
        Phase1WinLose: phase1ResData.phase1_promo_status,
        memberPromotionID: phase1ResData.member_promotion_id,
        p1AccumulatedAmount: phase1ResData.accumulated_target_amount,
        PPPhase2: phase1ResData.phase2_target_amount ? true : false
      } 
    });
  }

  @HostListener('window:resize', [])
  onResize() {
    if (window.innerHeight < this.windowInnerHeight) {
      $('#wrapper-container').css("padding-bottom", "0");
    } else {
      $('#wrapper-container').css("padding-bottom", "60px");
    }
  }

  async isValidImage(url: string): Promise<boolean> {
    return new Promise((resolve) => {
      if ((environment.sitePrefix.toLowerCase() == 'ppaq' || environment.sitePrefix.toLowerCase() == 'ozpk') && window.location.pathname != '/landing') {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      } else {
        resolve(false);
      }
    });
  }

}
